import './tarot-section.scss';

export default function TarotSection() {
    return(
        <div className="sv-tarot-section">
            <div className="sv-tarot-section-grid">
                <div className='sv-tarot-section-grid-header'>
                    <span>tarot <span>reading</span></span>
                </div>
                <div className='sv-tarot-section-grid-content'>
                    <div className='sv-tarot-section-grid-content-image' />
                    <div className='sv-tarot-section-grid-content-outline'>
                        <div className='sv-tarot-section-grid-content-outline-text'>
                            <p>
                                Providing tarot readings is an intuitive process that helps individuals explore their thoughts and life situations through tarot cards. As an intuitive reader, I create a safe space for clients to share their questions, guiding them to gain insights that illuminate their paths.
                            </p>
                            <br />
                            <p>
                                My empathetic approach reveals unique perspectives and potential outcomes, encouraging clients to reflect on their choices and empowering them to take proactive steps toward their goals. Ultimately, tarot readings promote clarity, self-discovery and personal growth.  Fostering a deeper connection with one's intuition and wisdom.
                            </p>
                            <br />
                            <p>
                                Whether you're facing a crossroads or seeking insight, I invite you to explore the possibilities.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}